import { getEXRApi } from "./getEXRApi";

export const getEXRSetData = async (
    lang,
    setMessageResponse,
    cookies,
    setEXRData,
    setEXRLoading,
    setData
) => {
    const response = await getEXRApi(lang, cookies);
    if (response.success) {
        console.log(response.res.data.data.RMB.rate);
        setData((prev) => ({ ...prev, exchangeRateRMB: response.res.data.data.RMB.rate }))
        setEXRData(() => response.res.data.data.RMB.rate);
        setEXRLoading(true);
    } else {
        const error = response.res;
        if (error.response) {
            setMessageResponse((prev) => ({
                ...prev,
                success: false,
                message: error.response.data.message,
                isShow: true,
            }));
        } else {
            setMessageResponse((prev) => ({
                ...prev,
                success: false,
                message: "Timeout",
                isShow: true,
            }));
        }
    }
};
